'use strict';

import React, { Component } from 'react';

import styles from './assets/indexResponse.module.css';

const print = function (value) { };
class DDS_lanhupage_1 extends Component {
  state = {};
  setValue(val) { }
  constructor(props) {
    super(props);
    this.state = {
      currentSlideIndex: props.currentSlideIndex,//liuxue,uk,usa,au,language,culture
    };
  }
  onNextSlide = () => {
    //var i = this.state.currentSlideIndex + 1;
    //this.props.onClickNextcurrentSLide(i)
    document.getElementById('mainwrap').scrollBy({
      top: 20, // 垂直滚动500px
      left: 0, // 水平位置（这里不改变）
      behavior: 'smooth' // 平滑滚动效果
    });
  }

  render() {
    return (
      <div className={`${styles.page} flex-col indexResponse_page__1c1a0`}>
        <div className={`${styles['box_18']} indexResponse_box_18__Z95vz  flex-col`}>
          <div className={`${styles['box_19']} flex-row indexResponse_box_19__QnBIi`}>
            <div className={`${styles['image-wrapper_4']} flex-col justify-between indexResponse_image-wrapper_4__vVklQ`}>
              <img
                onClick={() => this.onNextSlide()}
                className={`clickable`}
                src={
                  require('./assets/img/SketchPngd08825a154ca581054fc75372f7edca364d9ed279fa43b889c445ea09526f894.png')
                }

              />
              <img
                className={`clickable`}
                src={
                  require('./assets/img/SketchPng1043bd5c5c67398c345b9723acb5e8d9485cafdf0c89eca728c1f52603b44a47.png')
                }
                onClick={this.handleButtonClick}
              />
              {/* <div className={`clickable imgbaoming`} onClick={() => window.open("https://sjtuoa.imasedu.com/#/stuEnrolled?tenant_id=aa12d45f6f21422194836b2cc353e09c", '_blank')}>
                <img src={
                  require('../../components/assets/img/baoming.png')
                } ></img>
              </div>
              <div className='text_baoming'>网上报名</div> */}
            </div>
            <div className={`${styles['box_3']} flex-col indexResponse_box_3__T9fAr`}>
              <div className={`${styles['group_4']} flex-col indexResponse_group_4__CDFXq`} />
            </div>
            <img
              className={`${styles['image_6']} indexResponse_image_6__1q8nq`}
              src={
                require('./assets/img/SketchPng2a8675b81e27764903f1304c221689ced87ea3dbbfa3996be807f85d83d596d3.png')
              }
            />
          </div>
          <div className={`${styles['block_3']} flex-col indexResponse_block_3__3uHBo  fade-out indexResponse_block_3__gmmLp`}>
            <div className={`${styles['section_5']} flex-row justify-between indexResponse_section_5__3ffSf`}>
              <span className={`${styles['paragraph_1']} animate_slide indexResponse_paragraph_1__1wkB9`}>
                <div className='dv_style_bigfont letterSpace'>在开放中融汇智慧  </div>
                <div className='letterSpace'>在联动中创新教育</div>

                <div className='font-style-46 dv_single_word'>每一次互鉴，都是文化印记</div>
              </span>
              <div className={`${styles['section_6']} indexResponse_section_6__3HiTT  flex-col justify-between indexResponse_section_6__Rgrlh`}>
                <span className={`${styles['text_7']} indexResponse_text_7__2H3kp  indexResponse_text_7__xYxH2`}>YingJiaInternationl</span>
                <div className={`${styles['image-text_7']} flex-col justify-between indexResponse_image-text_7__3KsZj`}>
                  <div className={`${styles['box_4']} flex-col indexResponse_box_4__1E4Ky`} />
                  <span className={`${styles['text-group_1']} indexResponse_text-group_1__1IGij`}>首页</span>
                </div>
              </div>
            </div>
            <div className={`${styles['section_7']} indexResponse_section_7__14T86  flex-row justify-between indexResponse_section_7__1pniE`}>
              <div className={`${styles['section_1']} flex-row indexResponse_section_1__3KOKd indexResponse_section_1__2jgJX`}>
                {/* <div className={`${styles['image-text_8']} flex-row justify-between indexResponse_image-text_8__F_Onh `} onClick={() => {
                  window.open("https://ai.imasedu.com", '_blank');
                }}>
                  <span className={`${styles['text-group_2']} indexResponse_text-group_2__2aKvH `} >点击咨询</span>
                  <img
                    className={`${styles['label_1']}`}
                    src={
                      require('./assets/img/SketchPngd2349a5f07b00c012d52de23c774f9643242205efe55c5073ef96cda5a197319.png')
                    }
                  />
                </div> */}
              </div>
              <div className={`${styles['box_20']} flex-col justify-between indexResponse_box_20__2T-ov`}>
                <div className={`${styles['group_8']} flex-col indexResponse_group_8__1LOVv `} />
                <div className={`${styles['group_9']} flex-col indexResponse_group_9__U1Zqu `} />
              </div>
            </div>
            <div className={`${styles['section_8']} flex-row indexResponse_section_8__2QfZb `}>
              <div className={`${styles['group_11']} flex-col indexResponse_group_11__2_69u `} />
            </div>

          </div>
          <img
            className={`${styles['image_7']} fade-out indexResponse_image_7__-HRs9`}
            src={
              require('./assets/img/SketchPnge75d179e51982c2c0ca7c30eca70cd14136f77e2292d42a3cf1ead2a5ef9eb01.png')
            }
          />
        </div>
      </div>
    );
  }
}
export default DDS_lanhupage_1;
